import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import services from '../../ioc/services';
import 'react-dropdown/style.css';
import Select from 'react-select';
import { MultiSelectDropdown } from '../components';

export default function FormDropdown({ valueUpdater, defaultValue = [], isMultiple = false }) {

    const [forms, setForms] = useState([]);
    const [defaultSelected, setDefaultSelected] = useState([]);

    useEffect(() => {

        services.api.form.getForms()
            .then(res => {

                if (isMultiple) {
                    let formOptions = res.map(f => ({
                        value: f.id,
                        key: f.title
                    }));
                    setForms(formOptions)

                    setDefaultSelected(res
                        .filter(f => defaultValue.includes(f.id))
                        .map(f => ({ value: f.id, key: f.title }))
                    )
                }

                else {
                    let formOptions = res.map(f => ({
                        value: f.id,
                        label: f.title
                    }));

                    setForms(formOptions)

                    setDefaultSelected(res
                        .filter(f => defaultValue.includes(f.id))
                        .map(f => ({ value: f.id, label: f.title }))
                    )
                }

            })

    }, [defaultValue])



    return (

        <div className='flex-1'>
            {isMultiple ?
                <MultiSelectDropdown defaultValue={defaultSelected} options={forms} placeholder="Select Forms" valueUpdater={valueUpdater} />

                :

                <Select
                    onChange={valueUpdater}
                    defaultValue={defaultSelected}
                    options={forms}
                />}
        </div>
    )
}
